<template>
	
	<div class="shopaccess">
		<!-- 仓库对卖家发起积分扣减 -->
		<el-dialog
		:title="objTpp.userName"
		:visible.sync="payPoint"
		:close-on-click-modal="false"
		width="30%"
		>
		<div style="margin-bottom:30px">
			{{$t('other.a873')}}：
			<el-input-number size="mini" v-model="objTpp.payIntegral"   :label="$t('other.a936')"></el-input-number>
		</div>

		<el-input
		type="textarea"
		:autosize="{ minRows: 2, maxRows: 120}"
		:placeholder="$t('other.a1857')"
		v-model="objTpp.desc">
		</el-input>
		<span slot="footer" class="dialog-footer">
			<el-button @click="payPoint = false">{{$t('other.a106')}}</el-button>
			<el-button type="primary" @click="updataPoint()">{{$t('other.a279')}}</el-button>
		</span>
		</el-dialog>

		<el-dialog
		:label="$t('other.a2283')"
		:visible.sync="remarkDia"
		width="30%"
		>
		<el-input v-model="remarkName" :placeholder="$t('other.a2284')"></el-input>
		<span slot="footer" class="dialog-footer">
			<el-button @click="remarkDia = false">{{$t('other.a106')}}</el-button>
			<el-button type="primary" @click="comfirmRemark()">{{$t('other.a279')}}</el-button>
		</span>
		</el-dialog>
		<el-scrollbar>
			<!-- <Qrcode-Dialog :shopsalesVisible.sync="shopsalesVisible" /> -->
		<!-- 积分扣减明细明细-->
		<el-dialog :title="$t('other.a58')" :visible.sync="showChare" @close="$emit('update:intergralDia',false)" width="70%">
			<div style="width: 100%;">
				<div>
					<el-select @change="getRecharge()"  v-model="pay_Value" :placeholder="$t('other.a2199')" size="small">
							<el-option v-for="item in payTypeOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
					</el-select>
					<el-button style="margin:0 10px" size="small" type="primary" @click="exportXml()">{{$t('other.a2285')}}</el-button></el-button>
				</div>
				<div>
					<el-table :data="pointsInfomation" height="400px" style="width: 100%">
						<el-table-column :label="$t('other.a2200')" >
							<template slot-scope="props">
								<el-popover
									ref="popover4"
									placement="right"
									size="mini"
									trigger="hover">
									<el-table size="mini" :data="props.row.orderDeductions">
										<el-table-column width="150" property="orderId" :label="$t('other.a60')"></el-table-column>
										<el-table-column width="60" property="orderFee" :label="$t('other.a2201')"></el-table-column>
										<el-table-column width="180"  property="desc" :label="$t('other.a2202')" :show-overflow-tooltip="true"></el-table-column>
									</el-table>
								</el-popover>
								<span   v-popover:popover4>{{showChange(props.row.payType)}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a1843')">
							<template slot-scope="props">
								<span>{{props.row.changeIntegral}}</span>
							</template>
						</el-table-column>
						<el-table-column  :label="$t('other.a2203')">
							<template slot-scope="props">
								<span>{{props.row.oldIntegral}}</span>
							</template>
						</el-table-column>
						<el-table-column  :label="$t('other.a2204')">
							<template slot-scope="props">
								<span>{{props.row.newIntegral}}</span>
							</template>
						</el-table-column>
						<el-table-column  :label="$t('other.a2286')" :show-overflow-tooltip="true">
							<template slot-scope="props">
								<span>{{showStoreName(props.row.storeId)}}</span>
							</template>
						</el-table-column>
						<el-table-column  :label="$t('other.a2287')" :show-overflow-tooltip="true">
							<template slot-scope="props">
								<span>{{props.row.payWith}}</span>
							</template>
						</el-table-column>
						<el-table-column  :label="$t('other.a89')" :show-overflow-tooltip="true">
							<template slot-scope="props">
								<span>{{getTiem(props.row.createTime)}}</span>
							</template>
						</el-table-column>
						
					</el-table>
					<div style="width: 100%;display: flex;justify-content: flex-end;">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4"
						 :page-sizes="[15, 30, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="pointsInfomationNum">
						</el-pagination>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showChare=false">{{$t('other.a5')}} </el-button>
		
			</span>
		</el-dialog>

		<el-dialog
		  :title="$t('other.a2288')"
		  :visible.sync="DiaLogPrivateStore"
		  width="50%"
		  >
		  <div style="margin-bottom:20px;flot:right">
			  <el-button size="small" type="primary" @click="dialogVisible04=true">{{$t('other.a2289')}}</el-button>
		  </div>
		  <el-table
		     border
			:data="privateStoreList"
			style="width: 100%">
			<el-table-column
				prop="storeUserId"
				:label="$t('other.a2290')"
				width="180">
			</el-table-column>
			<el-table-column
				:label="$t('other.a57')"
				>
				<template slot-scope="props">
					<span>{{getTime(props.row.createTime)}}</span>
				</template>
			</el-table-column>
			<el-table-column
				:label="$t('other.a33')">
				<template slot-scope="props">
					<el-button size="mini" type="primary" @click="createDistributeStore(0,props.row)">{{$t('other.a2291')}}</el-button>
					<el-button size="mini" type="primary" @click="createDistributeStore(1,props.row)">{{$t('other.a2292')}}</el-button>
				</template>
			</el-table-column>
			</el-table>
		
		  <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="DiaLogPrivateStore = false">{{$t('shopaccess.cancel')}}</el-button>
		  </span> 
		</el-dialog>

		

		<!-- 仓库帐号设置卖家优惠 弹窗-->
		<el-dialog
		  :title="$t('other.a2293')"
		  :visible.sync="discount"
		  width="30%"
		  >
		  <el-form ref="form" :model="form" label-width="80px">
			<el-form-item :label="$t('other.a2294')">
				<span>{{form.seller}}</span>
			</el-form-item>
			<el-form-item :label="$t('other.a914')">
				<el-select v-model="form.storeId" :placeholder="$t('other.a2295')">
				<el-option :label="item.storeName" :value='item.storeId' v-for="(item,index) in storeOption" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('other.a2297')">
				<el-select v-model="form.discountType" :placeholder="$t('other.a2296')">
				<el-option :label="$t('other.a2298')" value='0'></el-option>
				<el-option :label="$t('other.a1874')" value='1'></el-option>
				<el-option :label="$t('other.a1875')" value='2'></el-option>
				<el-option :label="$t('other.a1876')" value='3'></el-option>
				<el-option :label="$t('other.a1877')" value='4'></el-option>
				<el-option :label="$t('other.a1878')" value='5'></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('other.a1862')">
				<el-input v-model="form.rate" :placeholder="form.discountType !== '0' ? descText : descCopy"></el-input>
			</el-form-item>
			
			
			</el-form>
 
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="discount = false">{{$t('shopaccess.cancel')}}</el-button>
		    <el-button type="primary" @click="addDiscount()">{{$t('shopaccess.comfirm')}}</el-button>
		  </span>
		</el-dialog>
		<!-- 仓库帐号查看卖家优惠 弹窗-->
		<el-dialog
		  :title="$t('other.a2299')"
		  :visible.sync="viewDiscount"
		  width="60%"
		  >
		  <el-select @change="showDiscountCopy()" v-model="warehoseValue" :placeholder="$t('other.a2295')">
				<el-option  :label="item.storeName" :value='item.storeId' v-for="(item,index) in storeOption" :key="index"></el-option>
				
				</el-select>

		  <el-table
			:data="sellerDiscountList"
			style="width: 100%">
			<el-table-column
				:label="$t('other.a1861')"
				>
				<template slot-scope="props">
					<span>{{showStoreName(props.row.storeId) }}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="discountType"
				:label="$t('other.a2297')"
				>
				<template slot-scope="props">
					<span>{{hdknv(props.row.discountType)}}</span>
					
				</template>
			</el-table-column>
			<el-table-column
				prop="rate"
				:label="$t('other.a271')">
				<template slot-scope="props">
					<span v-show=" props.$index !== indexOne">{{props.row.rate}}</span>
					<el-input v-show="indexOne == props.$index" v-model="props.row.rate" :placeholder="$t('other.a2300')"></el-input>
				</template>
			</el-table-column>
				<el-table-column
				prop="sellerId"
				:label="$t('other.a1558')">
			</el-table-column>
			<el-table-column
				:label="$t('other.a33')"
				>
				<template slot-scope="props">
					<el-button v-show=" props.$index !== indexOne" size="mini" type="primary" @click="modify(props.row,props.$index)">{{$t('other.a93')}}</el-button>
					<el-button v-show=" props.$index == indexOne" size="mini" type="primary" @click="comfirm(props.row,props.$index)">{{$t('other.a38')}}</el-button>
					<el-button size="mini" type="primary" @click="cancel(props.row,props.$index)">{{$t('other.a312')}}</el-button>
				</template>
			</el-table-column>
			</el-table>
 
		  <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="viewDiscount = false">{{$t('other.a5')}}</el-button>
		   
		  </span>
		</el-dialog>


		
	
		
		
		
	
		<div v-if="userPos === 'STORE'" class="deduction">
			<Dialog :intergralDia.sync="intergralDia"></Dialog>
			<div class="shop-detail">
				<div style="display: flex; margin-bottom: 20px;">
					<div>
					    <el-date-picker
					      v-model="value4"
					      type="datetimerange"
					      :picker-options="pickerOptions2"
					      :range-separator="$t('other.a47')"
					      :start-placeholder="$t('other.a45')"
					      :end-placeholder="$t('other.a46')"
						  @change="gibmv()"
					      format="yyyy-MM-dd"
					      value-format="yyyy-MM-dd"
					      align="right">
					    </el-date-picker>
					</div>
					  <el-button style="margin-left: 15px;"  type="primary" @click="getRecharge()">{{$t('homeTwo.pointdetails')}}</el-button>
				</div>
				<div style="font-size: 18px;padding: 10px;display: flex;">
					{{$t('homeTwo.Subwarehouse')}}
				</div>
				<div class="shop-item-title">
					<span ><el-checkbox v-model="chooseStoreAll" @change="getAllStore()"></el-checkbox></span>
					 <!-- <span class="title-item">{{$t('shopaccess.storeID')}}</span>
					 <span class="title-item">{{$t('shopaccess.userId')}}</span>
					 <span class="title-item">{{$t('shopaccess.userName')}}</span> -->
					 <span class="title-item">{{$t('shopaccess.storeName')}}</span>
					 <span class="title-item">{{$t('homeTwo.Warehousetype')}}</span>
					 <span class="title-item">{{$t('shopaccess.createTime')}}</span>
					 <span class="title-item">{{$t('shopaccess.storeAdresse')}}</span>
					
												 
				</div>
				<div v-if="!warehouse.length" style="width: 100%;text-align: center;padding: 20px 0;">--{{$t('other.a2301')}}--</div>
				<div v-else class="shop-item-list" v-for="(item,index) in warehouse" :key="index">
					<span ><el-checkbox v-model="item.checked" @change="getStoreList(item)"></el-checkbox></span>
					 <!-- <span class="list-item">{{item.storeId}}</span>
					 <span class="list-item">{{item.userId}}</span>
					 <span class="list-item">{{item.userName}}</span> -->
					 <span class="list-item">{{item.storeName}}</span>
					 <span class="list-item">{{storeTypeNum[item.storeType]}}</span>
					 <span class="list-item">{{getTime(item.createTime)}}</span>
					 <span class="list-item">{{getCountry(item.storeAddress)}}</span>
					 <!-- <span class="list-item ">
						 <el-button v-if="userPos === 'SELLER'" size="mini" type="danger" @click="uniteStore01(item)">{{$t('shopaccess.UniteStore')}}</el-button>
						 <el-button v-if="userPos === 'STORE'" size="mini" type="danger"  @click="deleteStore(item)">删除仓库</el-button>
					</span> -->
										 
				</div>
				<div style="font-size: 18px;padding: 10px;display: flex;">
					{{$t('homeTwo.Sellerusercurrentlybound')}}：{{$t('homeTwo.Quantity')}} {{storeBindShopList.length}}
					
				</div>
				 <div class="shop-item-title">
					 <span ><el-checkbox v-model="chooseAll" @change="getAll()"></el-checkbox></span>
					 <span class="title-item">{{$t('homeTwo.Sellersname')}}</span>
					 <span class="title-item">{{$t('homeTwo.SellersAccount')}}</span>
					 <span class="title-item">{{$t('homeTwo.boundtime')}}</span>
					 <span class="title-item">{{$t('homeTwo.operating')}}</span>
					
				 </div>
				 <div v-if="!storeBindShopList.length" style="width: 100%;text-align: center;padding: 20px 0;">--{{$t('other.a2302')}}--</div>
				 <div v-else class="shop-item-list" v-for="(item,index) in storeBindShopList" :key='index'>
					 <span ><el-checkbox v-model="item.checked" @change="getSellerList(item)"></el-checkbox></span>
					 <span class="title-item itemlist">{{item.userName}}</span>
					 <span class="title-item itemlist">{{item.userId}}</span>
					 <span class="title-item itemlist">{{getTiem(item.createTime)}}</span>
					 <span class="title-item itemlist">
						<div> <el-button size="mini" type="primary" @click="showDiscount(item)">{{$t('homeTwo.Viewselleroffers')}}</el-button></div>
						<div style="margin-top:10px"> <el-button size="mini" type="primary" @click="setDiscount(item)">{{$t('homeTwo.Setupselleroffers')}}</el-button></div>
						<div style="margin-top:10px" v-show="userId == 'ABH_Int' || userId== 'thstock'"> <el-button size="mini" type="primary" @click="getSellerPoint(item)">{{$t('other.a2303')}}</el-button></div>
					 </span>
				 </div>			
			</div>
		</div>
		</el-scrollbar>
		
	</div>
</template>

<script>
import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
import config from './config'
import shopaccessApi from '../../api/moudles/shopaccess.js'
import echarts from 'echarts'
import Dialog from '../../components/dialog/dialog.vue'
import md5 from 'js-md5';
import api2 from '../../api/api'
import api from '../../api/moudles/deduction'
import utils from '../../utils/utils.js'
import { mapState, mapActions, mapMutations} from 'vuex'
import { join, resolve } from 'path'
import { rejects } from 'assert'
export default {
	bebforeRouterEnter(to,from,next) {
		from.meta.keepAlive=false
	},
	data(){
		return{
			...config,
			boundDesc:'',
			objTpp:{
				desc:null,
				password:'xrkj123@@',
				payIntegral:0,
				partnerId:null,
				sellerId:JSON.parse(JSON.stringify('userInfo')).userId,
				userId:'systemAdmin',
				storeId:null,
				userName:null,
				
			},
			showband:false,
			discount:false,
			storeType:null,
			sellerId:JSON.parse(JSON.stringify('userInfo')).sellerId,
			activeNum:-1,
			viewDiscount:false,
			payPoint:false,
			sellerDiscountList:[],
			storeBindShopList:[],
			remarkName:null,
			remarkDia:false,
			countryOption:[],
			dialogVisible05:false,
			warehoseValue:null,
			storeCharge:false,
			descText:this.$t('other.a2300'),
			descCopy:this.$t('other.a2304'),
			rechargeRulse:null,
			DiaLogPrivateStore:false,
			distributeStoreDia:false,
			storeTypeNum:[this.$t('other.a1893'),this.$t('other.a1894'),this.$t('other.a1895'),this.$t('other.a1896'),this.$t('other.a1897')],
			sellerId:null,
			privateStoreList:[],
			textDesc:'',
			invitationCode:null,
			invitationScan:null,
			isChildrenStore:false,
			indexOne:null,
			storeOption:JSON.parse(localStorage.getItem('userInfo')).stores,
			form:{
				discountType:'0',
				rate:null,
				seller:'',
				sellerId:null,
				storeId:null,
				viewDiscount:false,
				userId:JSON.parse(localStorage.getItem('userInfo')).userId
			},
			remarkParams:{},
			endTime:null,
			ruleForm:{
				applyDec:null,
				permit:0,
				storeId:null,
				userId:JSON.parse(localStorage.getItem('userInfo')).userId,
				storeUserId:null,
				store:{
					address:{
						address:null,
						city:null,
						name:null,
						phone:null,
						state:null,
					},
					storeAddress:null,
					storeName:null
				}
			},
			rules: {
			applyDec: [
				{ required: true, message: this.$t('other.a2305'), trigger: 'blur' },
			],

			
			'store.storeAddress': [
				{ required: true, message: this.$t('other.a644'), trigger: 'blur' }
			],
			'storeUserId': [
				{ required: true, message: this.$t('other.a2295'), trigger: 'blur' }
			],
			'store.address.address': [
				{ required: true, message: this.$t('other.a2306'), trigger: 'blur' }
			],
			'store.address.name': [
				{ required: true, message: this.$t('other.a2307'), trigger: 'blur' }
			],
			'store.address.phone': [
				{ required: true, message: this.$t('other.a2308'), trigger: 'blur' }
			],
			'store.storeName': [
				{ required: true, message: this.$t('other.a2309'), trigger: 'blur' }
			],
			
			},
			privatedStoreOption:[],
			newObj:{
				country:null,
				password:null,
				storeName:null,
				userId:JSON.parse(localStorage.getItem('userInfo')).userId
			}
		
		}
	},
	
	computed:{
		...mapState({
			userId: state=>state.login.userInfo.userId || '',
			country:state=>state.login.userInfo.country,
			shopList: state => state.shopaccess.shopInfo || '',
			warehouse: state => state.shopaccess.warehouse || '',
			userPos: state=>state.login.userInfo.userPos || '',
			Successed: state=>state.shopaccess.Successed,
			sistemAllstore: state=>state.shopaccess.sistemAllstore,
			lazadashopinfo: state=>state.shopaccess.lazadashopinfo,
			// storeBindShopList: state=>state.deduction.storeBindShopList,
		}),
	
	},
	components:{
		QrcodeDialog,
		Dialog
	},
	
	watch:{
		storeAccount(){
			if(!this.storeAccount){
				this.activeNum=-1
			}
		},
		discount(){
			if(!this.discount){
				this.form={
					discountType:'0',
					rate:null,
					seller:'',
					sellerId:null,
					storeId:null,
					viewDiscount:false,
					userId:JSON.parse(localStorage.getItem('userInfo')).userId
				}
			}
		},

		payPoint(){
			if(!this.payPoint){
				this.objTpp={
				desc:null,
				password:'xrkj123@@',
				payIntegral:0,
				sellerId:JSON.parse(JSON.stringify('userInfo')).userId,
				userId:'systemAdmin',
				token:'ItsXgkuRhZl2z26rMMTY5QTLKGEMdM'
				}
			}
		},

		dialogVisible04(){
			if(!this.dialogVisible04){
				this.storeAccount=''
				this.warehouseName=''
				this.password=''
				this.password01=''
			}
		},
		dialogVisible05(){
			if(!this.dialogVisible05){
				this.invitationScan=''
				
			}
		},
		Successed(){
			this.upDatePages()
		},
		showChare(){
			if(!this.showChare){
				// this.init()
				this.chooseStoreAll=false
				this.chooseAll=false
			}
		},
		dialogVisible02(){
			if(!this.dialogVisible02){
				this.userName=""
				this.storeName=""
				this.value=""
			}
		},
		distributeStoreDia(){
			if(!this.distributeStoreDia){
				this.ruleForm.applyDec=''
				this.ruleForm.storeUserId=''
				this.ruleForm.store.address.address=''
				this.ruleForm.store.address.name=''
				this.ruleForm.store.address.phone=''
				this.ruleForm.store.storeAddress=''
				this.ruleForm.store.storeName=''
				
				
				
			}
		}
	},
	
	created(){
		//获取积分收费名称
		this.payTypeOptions=utils.chargeNameOptions()
		this.init()
		
	
	},
	
	methods:{
		...mapActions('shopaccess',[
			'getLockShopID',
			'getUserInfo',
			'createWarehouse',
			'bindWarehouse',
			'searchWarehouse',//获取卖家帐号下所有仓库
			'getAllstore',//获取仓库帐号下所有仓库
			'getAllstoreALL', //获取系统内所有的仓库
			'sellerBindStore',//卖家帐号绑定仓库
			'unboundShop',//解绑商店
			'getShopAuthorization',
			'unboundStore',
			'getlazadaAuthorizationUrl',
			'getLazadaShop',
			'deleteWarehouse',
			'getShopSale',
			'getUserStock',
			'createPrivateStore',
			'getSellerPrivateStore'
			
		]),
		...mapActions('deduction',[
			'getStroeSeller',
		]),
		...mapActions('recharge',[
			'pointChange'
		]),
		...mapActions('order',[
			'getunprocessOrder'
			
		]),
		...mapMutations('login', [
			'SET_STORAGE_USERINFO',
				
		]),

		...mapMutations('shopaccess', [
			'SET_STORAGE_TTP',
			'GET_LAZADA_SHOP',
			'DELET_HAS_CLAIM_ALL',
				
		]),



		updataPoint(){
			
			console.log('warehouse',this.warehouse)
			this.objTpp.userId=this.userId
			this.objTpp.storeId=this.warehouse[0].storeId
			let obj=JSON.parse(JSON.stringify(this.objTpp))
			obj.payIntegral=-obj.payIntegral
			// 负数为扣减卖家积分，正数为退还卖家积分
			console.log('obj',obj)
			if(obj.payIntegral== 0 ){
				this.$message.warning(this.$t('other.a1880'))
				return
			}else if(!obj.desc){
				this.$message.warning(this.$t('other.a1881'))
				return
			}
			console.log('deductionPoints',obj)
			shopaccessApi
			.deductionPoints(obj)
			.then(res => {
			if(res.code === 200 ){
			console.log('desc',res.data)
			this.$message.success(this.$t('other.a2310'))
			this.payPoint=false
			}else{
			this.$message.warning(res.msg)
			}
			})

		},
		
		

		comfirmRemark(){
			this.remarkParams.remark=this.remarkName
			console.log(this.remarkParams)
			api2
			.updateShopRemark(this.remarkParams)
			.then(res => {
			if(res.code === 200 ){
			console.log('desc',res.data)
			this.$message.success(this.$t('other.a2311'))
			setTimeout(() => {
				location.replace('./index')
			},200)
			this.init()
			}else{
			this.$message.warning(res.msg)
			}
			})
			
		},

		kvhmf(shopId){
			this.remarkDia=true
			this.remarkParams.shopId=shopId
			this.remarkParams.userId=this.userId

		},

		hdknv(id){
			const params={
				'0':this.$t('other.a2298'),
				'1':this.$t('other.a1874'),
				'2':this.$t('other.a1875'),
				'3':this.$t('other.a1876'),
				'4':this.$t('other.a1877'),
				'5':this.$t('other.a1878')
			}

			return params[id]
		},

		

		bingAlliance(){
			console.log(this.invitationScan)
			shopaccessApi
			.bindLeagueStore({invitationCode:this.invitationScan,userId:this.userId})
			.then(res => {
				if(res.code === 200) {
					this.$message.success(this.$t('other.a2312'))
					this.dialogVisible05=false
					this.getUserInfo({userId:this.userId})
				}else{
					this.$message.warning(res.msg)
				}
			})
		},

		getRules(id){
			let storeRules=JSON.parse(localStorage.getItem('userInfo')).stores.filter(item => item.storeId == id)
			this.rechargeRulse=storeRules
			this.storeCharge=true
			
			console.log(storeRules)
		},

		generateDistrubuteStore(){
			this.$refs.ruleForm.validate((valid) => {
			if (valid) {
					console.log('ruleForm',this.ruleForm)
					if(this.isChildrenStore){//建私有仓子仓
						shopaccessApi
						.sellerAddPrivateStore({
							storeName:this.ruleForm.store.storeName,
							storeAddress:this.ruleForm.store.storeAddress,
							userId:this.ruleForm.userId,
							sellerId:this.ruleForm.storeUserId
						})
						.then(res => {
							if(res.code === 200) {
								this.$message.success(this.$t('other.a2313'))
								this.distributeStoreDia=false
							}else{
								this.$message.warning(res.msg)
							}
						})

					}else{//建分稍仓子仓
					
					shopaccessApi
					.addDistributionStore(this.ruleForm)
					.then(res => {
						if(res.code === 200) {
							this.$message.success(this.$t('other.a2314'))
							this.distributeStoreDia=false
						}else{
							this.$message.warning(res.msg)
						}
					})

					}
					
			} else {
				this.$message.warning(this.$t('other.a2315'))
				return false;
			}
			});
		
		},
	
		//卖家帐号新建分销子仓
		createDistributeStore(num,item){
			console.log(num,item)
			this.distributeStoreDia=true
			if(num == 0){//新建分销子仓
				this.isChildrenStore=false
				this.ruleForm.storeUserId=item.storeUserId
			}else if(num == 1){//新建私有仓子仓
				this.isChildrenStore=true
				this.ruleForm.storeUserId=item.storeUserId
			}

			console.log(this.ruleForm)
			
		},

		createStoreByStore(num){
			this.storeType=num
			if(num == 1){
				this.textDesc=this.$t('other.a2316')
			}
			if(num == 3){
				this.textDesc=this.$t('other.a2317')
			}
			this.dialogVisible02=true
		},

		modify(item,index){
			console.log(item,index)
			this.indexOne=index
		},

		comfirm(item,index){
			item.userId=this.form.userId
			let ttp=/^0\.[0-9]{1,2}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/
			if(!ttp.test(item.rate)){
				this.$message.warning(this.$t('other.a2318'))
				return
			}
			console.log(item,index)
			this.indexOne=null

			let parmas={
				discountType:item.discountType,
				rate:item.rate,
				sellerId:item.sellerId,
				storeId:item.storeId,
				userId:item.userId


			}

			shopaccessApi
			.setSellerDiscount(parmas)
			.then(res => {
				if(res.code === 200) {
					console.log('resdata',res.data)
					this.$message.success(this.$t('other.a665'))
					
				}
			})
		},

		cancel(item,index){
			console.log(index)
			shopaccessApi
			.deleteSellerDiscount({discountId:item.discountId,storeId:item.storeId,userId:this.form.userId})
			.then(res => {
				if(res.code === 200) {
					this.$message.success(this.$t('other.a1232'))
					this.sellerDiscountList.splice(index,1)
				}
			})
		},	


		addDiscount(){
			let ttp=/^0\.[0-9]{1,2}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/
			
			let service=Number(this.form.rate)
			let discountType=this.form.discountType
			
			
			if( discountType == '0' &&  service < 0.7){
				this.$message.warning(this.$t('other.a2319'))
				return
			}
			
			if(!this.form.storeId){
				this.$message.warning(this.$t('other.a2320'))
				return
			}

			console.log(service)

			// if(!ttp.test(this.form.rate)){
			// 	this.$message.warning(this.$t('other.a2318'))
			// 	return
			// }

			shopaccessApi
			.setSellerDiscount(this.form)
			.then(res => {
				if(res.code === 200) {
					console.log('resdata',res.data)
					this.$message.success(this.$t('other.a741'))
					this.discount=false
				}else{
					this.$message.warning(res.msg)
				}
			})
			
			
		},

		getSellerPoint(item){
			console.log(item)
			let  userInfo=JSON.parse(localStorage.getItem('userInfo'))
			let  sellers=userInfo ? userInfo.sellers : []
			let partnerId=sellers.find(p => p.userId == item.userId)
			this.payPoint=true
			this.objTpp.sellerId=item.userId
			this.objTpp.partnerId=partnerId.partnerId
			this.objTpp.userName=this.$t('other.a2321')+item.userName + this.$t('other.a2322')
			console.log('objTpp',this.objTpp)
			
		},

		setDiscount(item){
			console.log(item)
			this.discount=true
			this.form.seller=item.userName
			this.form.sellerId=item.userId
		},

		showDiscount(item){
			console.log(item)
			this.warehoseValue=JSON.parse(localStorage.getItem('userInfo')).stores[0].storeId
			this.sellerId=item.userId
			let params={
				sellerId:item.userId,
				storeId:this.warehoseValue,
				userId:JSON.parse(localStorage.getItem('userInfo')).userId
				
			}
			shopaccessApi
			.getSellerDiscount(params)
			.then(res => {
				if(res.code === 200) {
					console.log('卖家优惠',res.data)
					this.sellerDiscountList=res.data
					this.viewDiscount=true
					
				}
			})
		},

		showDiscountCopy(){
			let params={
				sellerId:this.sellerId,
				storeId:this.warehoseValue,
				userId:JSON.parse(localStorage.getItem('userInfo')).userId
				
			}
			shopaccessApi
			.getSellerDiscount(params)
			.then(res => {
				if(res.code === 200) {
					console.log('卖家优惠',res.data)
					this.sellerDiscountList=res.data
					
					
				}
			})
		},

		vetifyAcount(){
			shopaccessApi
			.getDistributionStore({userId:this.userId})
			.then(res => {
			if(res.code === 200 ){
			console.log('desc',res.data)
			}else{
			this.message.warning(res.msg)
			}
			})

			this.dialogVisible04=true
		},

		viewPrivateAccount(){
			shopaccessApi
			.getDistributionStore({userId:this.userId})
			.then(res => {
			if(res.code === 200 ){
			console.log('desc',res.data)
			this.DiaLogPrivateStore=true
			this.privateStoreList=res.data
			}else{
			this.message.warning(res.msg)
			}
			})
		},



		checkStore(){
			shopaccessApi
			.checkPrivateStore({userId:this.storeAccount})
			.then(res => {
				if(res.code === 200) {
					console.log(res.data)
					this.activeNum=1
				}else{
					this.activeNum=2
					this.$message.error(this.$t('other.a2323'))
				}
			})
		},

		checkChildrenWarehose(){
			shopaccessApi
			.checkChildrenStore({storeName:this.storeName})
			.then(res => {
				if(res.code === 200) {
					console.log(res.data)
				}
			})
		},


		showChange(id){
			console.log('payTypeOptions',this.payTypeOptions)
			let ttp=this.payTypeOptions.find(item => item.value == id)
			if(ttp){
				return ttp.label
			}else{
				return id
			}
		},
		//
		showStoreName(id){
			return utils.showstoreNameBystoreId(id)
		},
        //获取积分变化明细
		getRecharge(){
			let params={
				payType:this.pay_Value,
				offset:this.pagesize,
				page:this.page,
				sellerIds: this.sellerIdList,
				shopIds:this.shopIds,
				storeIds:this.storeList,
				end:this.value4[1],
				start:this.value4[0].slice(0,10),
				userId:this.userId
			}
			console.log(params)
			api
			.getIntegralLog(params)
			.then(res => {
				if(res.code === 200) {
					console.log('收入支出',res.data)
					this.showChare=true
					this.pointsInfomation=res.data.logs
					this.pointsInfomationNum=res.data.count
					if(this.changType){
						this.pointsInfomation_Copy=res.data.logs
					}
				}
			})
		},
		getDay(day) {
			var today = new Date();
			var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
			today.setTime(targetday_milliseconds); //注意，这行是关键代码
			var tYear = today.getFullYear();
			var tMonth = today.getMonth();
			var tDate = today.getDate();
			tMonth = this.doHandleMonth(tMonth + 1);
			tDate = this.doHandleMonth(tDate);
			return tYear + "-" + tMonth + "-" + tDate;
		},
		exportXmlCopy(){
			this.showChare=true
			this.changType=true
		},
		
		exportXml(){
			console.log(this.pointsInfomation)
			let params={
				payType:this.pay_Value,
				offset:this.pagesize,
				page:null,
				sellerIds: this.sellerIdList,
				storeIds:this.storeList,
				end:this.value4[1],
				start:this.value4[0],
				userId:this.userId
			}
			api
			.getIntegralLog(params)
			.then(res => {
				if(res.code === 200 ){
					let arr=[]
						res.data.logs.forEach(p => {
							arr.push({
								'支付类型':this.showChange(p.payType),
								'支付单号':p.payOrderId,
								'支付积分':p.changeIntegral,
								'积分变化前':p.oldIntegral,
								'积分变化后':p.newIntegral,
								'收款方':this.showStoreName(p.storeId),
								'付款方':p.payWith,
								'时间':utils.renderTime(p.createTime),
							})
						})
				
					console.log(arr)
					utils.exportProcessedOrder(arr)
				}
			})
			console.log(params)
		},
		
		getAll(){
			
			if(this.chooseAll){
				this.storeBindShopList.forEach(p => {
					p.checked=true
					this.getSellerList(p)
				})
			}else{
				this.storeBindShopList.forEach(p => {
					p.checked=false
					this.getSellerList(p)
				})
			}
			
			
			
		},
		
		getAllStore(){
			if(this.chooseStoreAll){
				this.warehouse.forEach(p => {
					p.checked=true
					this.getStoreList(p)
				})
			}else{
				this.warehouse.forEach(p => {
					p.checked=false
					this.getStoreList(p)
				})
			}
			
			
			
		},
		
		getStoreList(item){
			console.log(item)
			if(item.checked) {
				this.storeList.push(item.storeId)
				if(this.storeList.length > this.warehouse.length){
				this.storeList=[]
				}
				this.storeList.push(item.storeId)
				this.storeList=utils.unique(this.storeList)
			}else if(!item.checked){
				this.storeList.forEach((p,index) => {
					if(p === item.storeId){
						this.storeList.splice(index,1)
					}
				})
			}
			console.log(this.storeList)
		},
		
		getSellerList(item){
			
			
			if(item.checked) {
				this.sellerIdList.push(item.userId)
				if(this.sellerIdList.length > this.storeBindShopList.length){
				this.sellerIdList=[]
				}
				this.sellerIdList.push(item.userId)
				this.sellerIdList=utils.unique(this.sellerIdList)
			}else if(!item.checked){
				this.sellerIdList.forEach((p,index) => {
					if(p === item.userId){
						this.sellerIdList.splice(index,1)
					}
				})
			
			}
			
			console.log(this.sellerIdList)
		},
		getTiem(time){
			return utils.renderTime(time)
		},
		
		viewOption(item){
			this.intergralDia=true
		
		},
		registore(){
			console.log(this.newObj)
			if(!this.newObj.country){
				this.$message.warning(this.$t('other.a2324'))
				return
			}
			if(!this.newObj.storeName){
				this.$message.warning(this.$t('other.a2325'))
				return
			}
			if(!this.newObj.password){
				this.$message.warning(this.$t('other.a2326'))
				return
			}
	
			let ttp=JSON.parse(JSON.stringify(this.newObj.password))
			this.newObj.password=md5(this.newObj.password + 'seller'),

			shopaccessApi
			.createPrivateStore(this.newObj)
			.then(res => {
				if(res.code === 200) {
					console.log(res.data)
					let test=this.$t('other.a2327')+res.data.userId + this.$t('other.a2328') + ttp
					
					this.$confirm(test, this.$t('other.a2329'), {
					confirmButtonText: this.$t("other.a884"),
				
					type: 'success'
					}).then(() => {
						if(res.data){

							this.privateStoreList.push(res.data)
						}
						this.newObj.password=''
						this.newObj.country=''
						this.newObj.storeName=''
					})
				}else{
					this.$message.warning(res.msg)
					this.newObj.password=''
					this.newObj.country=''
					this.newObj.storeName=''
				}
			})
			// this.dialogVisible04=false
			
			
		},
		
		JVNHF(){
			let arr=this.sistemAllstore.filter(p => {
				if(p.storeId !== 10100006){
					return p
				}
			})
			return arr
		},
		//查看店铺销售情况
		viewShopSales(item){
			this.shopsalesVisible=true
			this.getShopSale({
				end:utils.getRecentSevenDay(0),
				start:utils.getRecentSevenDay(-7),
				shopId:item.shopId,
				userId:this.userId
			})
		},
		//删除仓库
		deleteStore(item){
			console.log(item)
			this.deleteWarehouse({
				storeId:item.storeId,
				userId:item.userId
			})
		},
		
		getEcharts(){
			console.log(document.getElementById('chartDom'))
			this.chatsRadios=echarts.init(document.getElementById('chartDom'))
			this.chatsRadios.setOption(this.storeCharge)
		},
		init(){
			// this.getStoreInfo() //获取绑定仓库按钮的选项
		    if(this.userPos === 'STORE'){
				this.storeBindShopList=[]
				console.log(this.storeBindShopList)
				this.sellerIdList=this.storeBindShopList.map(p => {
					return p.userId
				})
				this.storeBindShopList=JSON.parse(localStorage.getItem('userInfo')).sellers ? JSON.parse(localStorage.getItem('userInfo')).sellers : []

			}

			console.log(this.storeBindShopList)

			this.countryOption=utils.getCountryOption()
			this.otnmgv() //判断url中是否有授权的店铺Id
			// this.getLazadaShop_lazada() //获取lazada商店
			// this.getUserStock({account:"thstock"})
			let start=utils.getRecentSevenDay(-30)
			let end=utils.getRecentSevenDay(1)
			this.value4=[start,end]

			
		},
		openWindow(){
			let url = 'https://www.yuque.com/dongtiandeyinghuochong/qtw9rm/puf5t2'
			window.open(url)
		},


		getShopAuthorization_lazada(){
			
			let url = "https://auth.lazada.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=https://erp.shopsbu.com/erp/callBack/lazadaCallBack&client_id=123391&state=" + this.userId;
			
			window.open(url)
			// const params={
			// 	userId:this.userId
			// }
			// this.getlazadaAuthorizationUrl(params)
		},
		getLazadaShop_lazada(){
			const params={
				userId:this.userId
			}
			this.getLazadaShop(params)
		},
		uniteStore01(item){
			console.log(item.storeId)
			let params={
				userId:this.userId,
				storeId:item.storeId
			}
			this.unboundStore({payload:params,text:this.$t('shopaccess').UniteStoreSuccess})
			setTimeout(() => {
				location.replace('./index')
			},500)
		},
		handleSizeChange(val) {
			this.pagesize=Number(`${val}`)
			console.log('每面显示的数量',this.pagesize);
			this.handleCurrentChange()
		},
		
		gibmv(){
			
			
			this.value4[1]=utils.CurdateAddoneday(this.value4[1])
			console.log(this.value4)
			// let time=new Date(this.value4[1])
			// time=time.setDate(time.getDate()+1)
			// time=new Date(time)
			//   var Y = time.getFullYear()
			//   var M = time.getMonth() + 1
			//   var D = time.getDate()
			//   time = Y + (M < 10 ? "-0" : "-") + M + (D < 10 ? "-0" : "-") + D
			//   this.endTime=time
			//   console.log(time)
		},
		handleCurrentChange(val) {
			let num=Number(`${val}`)
			this.page=(num-1)*this.pagesize		
			this.getRecharge()
		},
		openAuthorization(){
			 let url=location.href
			 let baseUrl=''
			console.log(url)
			if(url.indexOf('dianxiaosheng') > -1) {
				baseUrl='https://partner.shopeemobile.com/api/v1/shop/auth_partner?id=843035&token=5c9174fc6006107dfb919c806da054e7725e35473afb4e0b7a943d61f9070620&redirect=https://erp.dianxiaosheng.com/index'
			}else if(url.indexOf('weanaly') > -1){
				baseUrl='https://partner.shopeemobile.com/api/v1/shop/auth_partner?id=843035&token=ab433e8f80128cda181fc4cdad8a220ef72f58e4e0b9335ce52aa58020cc551b&redirect=https://erp.weanaly.com/index'
			}else if(url.indexOf('shopsbu') > -1){
				baseUrl='https://partner.shopeemobile.com/api/v1/shop/auth_partner?id=843035&token=b1b5f7336c83f97eccb7dca3a93ff9756b16ef3809be2d9cca7c58ad39cba49d&redirect=https://erp.shopsbu.com/index'
			}	
			window.open(baseUrl)
			// this.$message.warning('正在跳转授权页面，请稍候...')
			// setTimeout(() => {
			// 	window.location.href=baseUrl
			// },700)
			
		},

		openAuthorizationCopy(){
			let url=location.href
			 let baseUrl='https://partner.test-stable.shopeemobile.com/api/v1/shop/auth_partner?id=1001107&token=5a3b9c68e446b677ce46f273f1fece08e8e89dc7ddaf12ad672e87e11c0847ee&redirect=https://erp.shopsbu.com'
			console.log(url)
			window.open(baseUrl)
		
		},
		//页面创建时判断url中是否有shop_id
		otnmgv(){
			let newUrl=location.href
			if(newUrl.search("shop_id") == -1){
				return
			}else {
				let arr=newUrl.split(/=/)
				let shopid=parseInt(arr[arr.length-1])
				let params= {
					userId:this.userId,
					shopId:shopid
				}
				this.getLockShopID(params).then(res => {
					if(res.code === 200){
						this.$confirm(this.$t('other.a2330'), this.$t("other.a142"), {
						confirmButtonText: this.$t('other.a145'),
						cancelButtonText: this.$t('other.a146'),
						type: 'success'
						}).then(() => {
							this.getUserInfo({userId:this.userId})
						}).catch(() => {
							setTimeout(() => {
								location.replace('/index')
							},500)
						})
					}else{
						const confirmText = [res.msg + this.$t('other.a2331'),  this.$t('other.a2332')] 
						const newDatas = []
						const h = this.$createElement
						for (const i in confirmText) {
						newDatas.push(h('p', null, confirmText[i]))
						}
						this.$confirm(this.$t("other.a142"), {
						title:this.$t('other.a2333'),
						message: h('div', null, newDatas),
						showCancelButton: true,
						confirmButtonText: this.$t('other.a2334'),
						cancelButtonText: this.$t('other.a146'),
						type: 'error'
						}).then(() => {
							api
							.mandatorBind({
								force:true,
								shopId:shopid,
								userId:this.userId
							})
							.then(res => {
								if(res.code === 200) {
									this.$confirm(this.$t('other.a2330'), this.$t("other.a142"), {
									confirmButtonText: this.$t('other.a145'),
									type: 'success'
									}).then(() => {
										this.getUserInfo({userId:this.userId})
									}).catch(() => {
										this.getUserInfo({userId:this.userId})
									})
								}
							})
						
						}).catch(() => {
							setTimeout(() => {
								location.replace('/index')
							},500)
						})
					}
				})
				
			}
		},

	

	
		//判断当前帐号，获取当前帐号下的所有仓库
		getStoreInfo(){
			if(this.userPos === 'STORE'){
				this.getAllstore(this.userId)
			}else if(this.userPos === 'SELLER') {
				// this.searchWarehouse(this.userId)
				// this.getShopItems(this.userId)
				// this.getAllstoreALL({sellerName:this.userId})
				// this.getSellerPrivateStore({userId:this.userId})
			}
		},
		 showRouter () {
		      alert(this.userId)
		      this.reload()
		    },
		
		//国家转换
		getCountry(platform) {
			const country = {
			  TW: this.$t('h5.DSX_index_tw'),
			  PH:this.$t('h5.DSX_index_ph'),
			  MY:this.$t('h5.DSX_index_my'),
			  TH:this.$t('chat.Thailand'),
			  SG:this.$t('chat.Singapore'),
			  ID:this.$t('chat.Indonesia'),
			  VN:this.$t('h5.DSX_index_vn'),
			  BZ:this.$t('h5.DSX_index_bz'),
			  CN:this.$t('other.a2335')
			}
			return country[platform]
		},

		changeUser(item){
			console.log(item)
			shopaccessApi
			.updateStoreUsed({
				isUsed:item.isUsed,
				storeId:item.storeId,
				userId:this.userId

			})
			.then(res => {
				if(res.code === 200){
					this.getUserDetail()
					if(item.isUsed){
						this.$message.success(this.$t('other.a2336'))
					}else{
						this.$message.success(this.$t('other.a2337'))
					}
				}
			})
		},

		getUserDetail(){
			  shopaccessApi
			  .getUserInfo({userId:JSON.parse(localStorage.getItem('userInfo')).userId})
			  .then(res => {
				  if(res.code === 200){
					  console.log('重新获取一次帐号的信息',res.data)
					   this.DELET_HAS_CLAIM_ALL(res.data)
					  let data=res.data
					    if(data.shopeeShops || data.lazadaShops || data.tiktokShops){
							localStorage.setItem('shophasAuthorization', true)
						}else{
							localStorage.setItem('shophasAuthorization', false)
						}
						if(data.userPos=== 'STORE'){
							localStorage.setItem('shophasAuthorization', true)
							
						}

						this.GET_LAZADA_SHOP(data.lazadaShops)
						localStorage.setItem('userInfo', JSON.stringify(data))
						localStorage.setItem('shopIdInfo', JSON.stringify(data.shopeeShops))
						localStorage.setItem('warehouse', JSON.stringify(data.stores))
						localStorage.setItem('lazadashopId', JSON.stringify(data.lazadaShops))
						localStorage.setItem('temuAuth', JSON.stringify(data.temuAuth))
				  } 
			  })
		  },
		
		//国家转换
		getStatus(status) {
	
			let desc=""
			if(status === 'NORMAL'){
				desc=this.$t('other.a1082')
			}else{
				desc=this.$t('other.a1911')
			}
			return desc
		},
		//切割时间
		getTime(time){
			return utils.renderTime(time)
		},
		activeCurrent(index){
			for(let i in this.isShow) {
				this.isShow[i]=false
			}
			console.log(this.isShow)
			this.isShow[index]=true
		},
	
		//创建仓库
		lockShop(num){
			const ttp={
				userId: this.userId,
				userName:this.userName,
				storeName:this.storeName,
				storeAddress:this.value,
			}
			
			const params= {
				userId:this.userId,
				shopId:this.shopIdttp
				
			}
			
			if(num == 0) {
				this.getLockShopID(params)
				this.dialogVisible01=false
					setTimeout(() => {
						location.replace('./index')
					},500)
			}else if(num ===1){//新建子仓
				if(!this.userName || !this.storeName || !this.value) {
					this.$message.warning(this.$t('other.a2338'))
					return
				}
				console.log('子仓',ttp)
				if(this.storeType == 3){
					ttp.invitationCode=this.invitationCode
					shopaccessApi
					.addLeagueStore(ttp)
					.then(res => {
					if(res.code === 200) {
				        this.$message.success(this.$t('other.a2339'))
						this.dialogVisible02=false
						this.getUserInfo({userId:this.userId})
					}else{
						this.$message.warning(res.msg)
					}
					})
				}

				if(this.storeType == 1){
					api2
					.createWarehouse(ttp)
					.then(res => {
					if(res.code === 200 ){
					console.log('desc',res.data)
					}else{
					this.$message.warning(res.msg)
					}
					})
					
					
					
				}

				
			
				
			}else if(num === 2){
				const ttp={
					userId:this.userId,
					storeId:this.stroeIDvalue
				}
				this.sellerBindStore({payload:ttp,text:this.$t('shopaccess').bangdinSuccess})
				this.dialogVisible03=false
					setTimeout(() => {
				location.replace('./index')
			},500)
			}
		
			
			
		},
		//提前获取订单数据
		getOrderInfo(){
			const params={
				userId: this.userId,
				start: this.start_time,
				end: this.end_time,
			}

			this.getunprocessOrder(params)
		},
		//获取最近7天的时间
		getRecentSevenDay(day) {
		      var today = new Date();
		      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
		      today.setTime(targetday_milliseconds); //注意，这行是关键代码
		      var tYear = today.getFullYear();
		      var tMonth = today.getMonth();
		      var tDate = today.getDate();
		      tMonth = this.doHandleMonth(tMonth + 1);
		      tDate = this.doHandleMonth(tDate);
		      return tYear + "-" + tMonth + "-" + tDate;
		    },
		    doHandleMonth(month) {
		      var m = month;
		      if (month.toString().length == 1) {
		        m = "0" + month;
		      }
		      return m;
		},
		//刷新当前页面
		upDatePages(){
			location.reload()
		},
		//解绑商店
		unboundshopByselleer(id) {
			const params={
				shopId:id,
				userId:this.userId
			}

			this.$confirm(this.$t('other.a2340'), this.$t("other.a142"), {
			confirmButtonText: this.$t('other.a2341'),
			cancelButtonText: this.$t('other.a146'),
			type: 'warning'
			}).then(() => {
				console.log(params)
				shopaccessApi
				.unboundShop(params) 
				.then(res => {
					if(res.code === 200) {
						this.$message.success(this.$t('other.a210'))
						setTimeout(() => {
							location.replace('./index')
						},500)

					}else{
						this.$message.warning(res.msg)
					}
				})

			})
			
		},
		
		tableRowClassName({row, rowIndex}) {
		        if (rowIndex === 1) {
		          return 'warning-row';
		        } else if (rowIndex === 3) {
		          return 'success-row';
		        }
		        return '';
		      }
	}
	

}
</script>

<style>
.shopaccess{
	/* flex: 1;
	margin: 60px 0 0 235px; */
}
.shop-detail-title{
	width: 100%;
	padding-left: 20px;
	height: 30px;
	line-height: 30px;
	font-size: 20px;
}
.shopaccess .main-header{
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 60px;
	background-color: #eee;

	margin: 10px;
	padding: 0 10px;
}

.el-icon-edit{
	color: #409eff;
	font-size: 16px;
	margin-left: 10px;
	cursor: pointer;

}

.shopaccess .recharge_item{
	border-bottom: 1px #eee solid;
}

.shopaccess .shop-desc{
	display: inline-block;
	background-color: #409eff;
	padding: 5px 20px;
	text-align: center;
	margin: 0 15px;
	border-radius: 5px;
	color: #fff;
	cursor: pointer;
}

.shopaccess .userInfo{
	margin: 20px 10px;
	border-radius: 5px;
	box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.shopaccess .userInfo-item{
	padding: 20px 15px;
	font-size: 14px;
}

.shopaccess .shop-detail{
	margin: 20px 10px;
	box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
	border-radius: 5px;
	box-sizing: border-box;
	padding: 5px 15px;
}

.shopaccess .shop-item-title{
	display: flex;
	justify-content: space-between;
	border-bottom: 1px #eee solid;
	padding: 15px 0;
}

.shopaccess .ttp{
	width: 199px;
	height: 56px;
	font-size: 14px;
	line-height: 56px;
	text-align: center;
}

.shopaccess .list-item{
	display: inline-block;
	width: 30%;
	font-size: 12px;
	padding: 15px 0;
	
	text-align: center;
	
	
}
	.el-tooltip__popper{
		font-size: 16px!important;
	}

.shopaccess .el-table .warning-row {
    background: oldlace;
  }

 .shopaccess .el-table .success-row {
    background: #f0f9eb;
  }

.shopaccess .btn{
	
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.echartBox{
	display: flex;
	margin: 20px 10px;
	box-sizing: border-box;
	padding: 5px 15px;
	justify-content: space-between;
	box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.shopaccess .shop-item-list{
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px #eee solid;
}

.shopaccess .shop-item-list .cancel{
	background-color: #f56c6c;
	display: inline-block;
	width: 30px;
}

.shopaccess .itemlist{
	padding:  10px 0;
}
.shopaccess .itemlist:nth-child(6){
	cursor: pointer;
	color: #007EE5;
}
.shopaccess .title-item{
	display: inline-block;
	width: 30%;
	text-align: center;
}
.country-choose{
	width: 100%;
	margin-top: 10px;
}


	
</style>
